module.exports = __webpack_public_path__ + "static/media/Avenir-Black.7d6f76f2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Avenir-Black.eot
// module id = 70
// module chunks = 0